import { render } from "./RedirectView.vue?vue&type=template&id=62f8fb8f"
import script from "./RedirectView.vue?vue&type=script&lang=js"
export * from "./RedirectView.vue?vue&type=script&lang=js"

import "./RedirectView.vue?vue&type=style&index=0&id=62f8fb8f&scopen=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__